// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_j8-5";
export var filledCircle = "_j8-4";
export var historyEntry = "_j8-3";
export var messageSideLeft = "_j8-1";
export var messageSideRight = "_j8-2";
export var orderTrackingInfoContainer = "_j8-0";